import { createSlice } from '@reduxjs/toolkit';

export const mastheadSlice = createSlice({
	name: 'masthead',
	initialState: {
		size: null,
		body: null,
		image: null,
		video: null,
	},
	reducers: {
		setSize: (state, action) => {
			state.size = action.payload;
		},
		setBody: (state, action) => {
			state.body = action.payload;
		},
		setImage: (state, action) => {
			state.image = action.payload;
		},
		setVideo: (state, action) => {
			state.video = action.payload;
		},
	}
});

export const { setSize, setBody, setImage, setVideo } = mastheadSlice.actions;

export default mastheadSlice.reducer;